import { Box } from '@mui/material'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './components/Home'
import RoomsListPage from './pages/RoomsListPage'
import RoomDetails from './components/RoomDetails'
import Contact from './components/Contact'
import About from './components/About'
import Gallery from './components/Gallery'
import Footer from './components/sections/Footer'
import PrivacyPolicy from './components/legal/PrivacyPolicy'
import TermsAndConditions from './components/legal/TermsAndConditions'
import CancellationPolicy from './components/legal/CancellationPolicy'
import TopBar from './components/TopBar'
import SearchResults from './components/SearchResults'
import BookingPage from './pages/BookingPage'
import BookingSuccessPage from './pages/BookingSuccessPage'
import PaymentPage from './pages/PaymentPage'

const App = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopBar />
      <Navbar />
      <Box 
        component="main" 
        sx={{ 
          flex: 1,
          mt: '104px', // 40px (TopBar) + 64px (Navbar)
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rooms" element={<RoomsListPage />} />
          <Route path="/rooms/search" element={<SearchResults />} />
          <Route path="/rooms/:id" element={<RoomDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/booking-success" element={<BookingSuccessPage />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  )
}

export default App 